import axios from 'axios';
import store from '@root/store';
import router from '@root/router/index';
import Swal from 'sweetalert2';
import { shared } from '@/utils/shared';
const { hideLoader, showLoader } = shared();

// Set config defaults when creating the instance
const admin = axios.create();

admin.defaults.baseURL = process.env.VUE_APP_API_URL;

// دالة لإظهار نافذة إدخال رمز التحقق
function openOtpPrompt() {
  Swal.fire({
    title: "ادخل رمز التحقق",
    customClass: {
      title: "my-swal-title",
      popup: "my-swal-modal"
    },
    input: "text",
    inputPlaceholder: "رمز التحقق",
    showCancelButton: true,
    confirmButtonText: "تأكيد",
    cancelButtonText: "إلغاء",
    confirmButtonColor: "#dc661e",
    cancelButtonColor: "#6c757d",
    inputAttributes: {
      maxlength: 4,
      pattern: "[0-9]*",
      inputmode: "numeric",
      style: "text-align: center;"
    },
    didOpen: () => {
      const input = Swal.getInput();
      // منع إدخال غير الأرقام
      input.addEventListener("keypress", (e) => {
        if (!/[0-9]/.test(e.key)) {
          e.preventDefault();
        }
      });
      // منع لصق نص غير أرقام
      input.addEventListener("paste", (e) => {
        const paste = (e.clipboardData || window.clipboardData).getData("text");
        if (!/^\d+$/.test(paste)) {
          e.preventDefault();
        }
      });
    },
    inputValidator: (value) => {
      if (!value) {
        return "من فضلك أدخل رمز التحقق";
      }
      if (!/^\d{4}$/.test(value)) {
        return "من فضلك أدخل 4 أرقام فقط";
      }
    },
  }).then((result) => {
    if (result.isConfirmed) {
      showLoader();
      store
        .dispatch("admin/confirmReactivation", { device_type: 'web', otp: result.value })
        .then(async (response) => {
          let message = response.data.message;
          await store.dispatch('admin/fetchAuth', {});
          hideLoader();
          Swal.fire({
            title: "تم التفعيل",
            text: message,
            icon: "success",
            confirmButtonText: "موافق",
            confirmButtonColor: "#dc661e",
            customClass: {
              title: "my-swal-title",
              popup: "my-swal-modal"
            },
          }).then(() => {
            // 🚀 بعد نجاح التفعيل نعمل تحديث للصفحة
            window.location.reload();
          });
        })
        .catch((error) => {
          hideLoader();
          let message = error.response?.data?.message || "رمز غير صحيح";
          Swal.fire({
            title: "تنبيه",
            text: message,
            icon: "warning",
            confirmButtonText: "موافق",
            confirmButtonColor: "#dc661e",
            customClass: {
              title: "my-swal-title",
              popup: "my-swal-modal"
            },
          }).then((res) => {
            if (res.isConfirmed) {
              // 🔁 نرجع من البداية ونفتح نافذة إدخال الرمز من جديد
              openOtpPrompt();
            }
          });
        });
    }
  });
}

// request interceptor
admin.interceptors.request.use((request) => {
  // نحاول نجيبه من الـ Store
  let token = store.getters['admin/authToken'];
  
  // 💡 إضافة: لو الـ Store فاضي، جربه من الـ LocalStorage مباشرة
  if (!token) {
    token = localStorage.getItem('client/user-token');
  }

  if (token) {
    request.headers['Authorization'] = `Bearer ${token}`;
  }
  
  request.headers['Accept-Language'] = 'ar';
  return request;
});

// response interceptor
admin.interceptors.response.use(response => response, error => {

  hideLoader();

  if (!error.response) {
    return Promise.reject(error);
  }
  let code = error.response.data.code;
  let message = error.response.data.message;
  const { status } = error.response;

  if (status >= 500) {
    // alert(error.response);
  }

  if (status == 401) {
    store.commit('admin/clearAuthToken',{});
    router.push({ name: 'login' });
  }

  if (code == '06') {
    Swal.fire({
      title: "تنبيه",
      text: message,
      icon: "warning",
      confirmButtonText: "موافق",
      confirmButtonColor: "#dc661e",
      customClass: {
        title: "my-swal-title",
        popup: "my-swal-modal"
      },
      showCancelButton: true,
      confirmButtonText: "تجديد الإشتراك",
      cancelButtonText: "إلغاء",
    }).then((result) => {
      if (result.isConfirmed) {
        showLoader();
        store
          .dispatch("admin/requestReactivation", {})
          .then(() => {
            hideLoader();
            // نفتح نافذة إدخال رمز التحقق
            openOtpPrompt();
          })
          .catch((error) => {
            hideLoader();
            let message = error.response?.data?.message || "فشل طلب التجديد";
            Swal.fire({
              title: "تنبيه",
              text: message,
              icon: "warning",
              confirmButtonText: "موافق",
              confirmButtonColor: "#dc661e",
              customClass: {
                title: "my-swal-title",
                popup: "my-swal-modal"
              },
            });
            console.error("Reactivation request error:", error);
          });
      }
    });
  } else if (code == '05') {
    Swal.fire({
      title: "تنبيه",
      text: message,
      icon: "warning",
      confirmButtonText: "موافق",
      confirmButtonColor: "#dc661e",
      customClass: {
        title: "my-swal-title",
        popup: "my-swal-modal"
      },
    });
  }

  return Promise.reject(error);
});

export default admin;
